export default function access(initialState: {
  currentUser?: API.CurrentUser;
}) {
  const { currentUser } = initialState ?? {};

  return {
    canAdmin: currentUser && currentUser.type === 'admin',
    hasHrPagePermission: () => true,
    canManageFoundation: true,
  };
}
